module.exports = __webpack_public_path__ + "img/3.a05a54eb.png";